import type { PropsWithChildren } from 'react';

import cx from 'classnames';

type Props = PropsWithChildren<{
  as?: 'div' | 'section' | 'nav' | 'main' | 'footer';
  ref?: any;
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}>;

const OUTER_CONTAINER = 'px-4 sm:px-6';
const INNER_CONTAINER = 'mx-auto w-full max-w-6xl';

const BreakpointsContainer = ({ as: Element = 'div', className, style = {}, children, ref }: Props) => {
  return (
    <Element className={cx(OUTER_CONTAINER, className)} style={style} ref={ref}>
      <div className={INNER_CONTAINER}>{children}</div>
    </Element>
  );
};

export default BreakpointsContainer;
